import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAvailableData = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m11.824 22.184-6.496-6.496 2.828-2.828 3.668 3.668 7.83-7.831 2.828 2.828zm15.161-7.897H39.75v4H26.985zm5.081 25.11-6.495-6.495 2.828-2.829 3.667 3.667 7.831-7.83 2.828 2.829zM8.25 31.501h12.766v4H8.25z" })
});
export default SvgAvailableData;
